module.exports = __webpack_public_path__ + "img/n4.4e2d1886.svg";